import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { EDIT_TYPE, INSERT_TYPE, STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import {
  createAddiction,
  getAllAddictions,
  getAddictionById,
  updateAddiction,
} from "./services/addiction.services";
import { clearAddictionDetails } from "./addictionSlice";
import FormTextField from "../../components/formFields/FormTextField";

const CreateAddiction: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const AddictionDetail = useAppSelector(
    (state) => state.addiction.AddictionDetail
  );
  const AddictionsGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.addiction.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearAddictionDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (AddictionsGUID) {
      dispatch(getAddictionById(AddictionsGUID));
    }
  }, [AddictionsGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!AddictionsGUID) {
        const insertPayload = {
          Name: values.Name,
          IsActive: values.IsActive === 1,
          OperationType: INSERT_TYPE,
        };
        const response = await dispatch(createAddiction(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearAddictionDetails());
          dispatch(getAllAddictions());
        }
      } else {
        const editPayload = {
          ID: values.ID,
          AddictionsGUID: AddictionsGUID,
          Name: values.Name,
          IsActive: values.IsActive === 1,
          OperationType: EDIT_TYPE,
        };
        const response = await dispatch(updateAddiction(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearAddictionDetails());
          dispatch(getAllAddictions());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={AddictionDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {AddictionsGUID ? "Update Addiction" : "Create Addiction"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Name"
                label="Name"
                placeholder="Name"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                component={FormSelectionField}
                label={"Status"}
                placeholder="Status"
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={AddictionsGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateAddiction;
